<template>
  <div>
    <div class="brand">
      <p class="brandTop">会社情報</p>
      <div class="brand_img1">
        <img src="http://hten.isdg.cn/index/brand/brang_01.png">
      </div>
      <div class="brandContent">
        <p class="brandTitle">会社情報</p>
        <div class="brandCountMain">
          <table class="brandTbleOne">
            <tr v-for="item in table1">
              <td><span v-for="Message in item.tr">{{Message.title}}</span></td>
              <td><p v-for="Message in item.tr">{{Message.text}}</p></td>
            </tr>
          </table>
          <div class="projectimg">
            <img src="http://hten.isdg.cn/index/brand/project.jpg">
          </div>
          <p class="brandSrsc">十人十彩はこれからも安心・品質・技術を追求します</p>
          <div class="brandText">
            十人十彩は、お客様第一の品質管理方針に基づき、原料・資材の選定から、製品がお
            客様の手元に届くまで、きめ細かな管理を行っています。また、お客様のニーズを満
            たす製品を迅速に企画・開発し、原料中の添加物・残留農薬類の確認等細部にわたった
            チェックを行い、製造においても製造工程のチェックを徹底し、常に安心してお客様
            の満足を得られる製品づくりを目指しています。さらに、本社工場では従来型の健康
            食品以外に、オリヒロ独自の包装技術を使用した包装機を使用して、従来にない液体
            タイプの各種サプリメントの開発・製造をしております。これら生産部門と品質管理
            部門、研究開発部門、物流部門、営業部門と製販各部門が一体となってお客様第一主
            義の製品づくりを追求しています。
          </div>
          <div class="gongimg">
            <img src="http://hten.isdg.cn/index/brand/g_1.png">
            <img src="http://hten.isdg.cn/index/brand/g_2.png">
            <img src="http://hten.isdg.cn/index/brand/g_3.png">
          </div>
          <p class="brandSrsc">健康補助食品GMP認定「適合」の概要</p>
          <div class="brandGmp">
            <img src="http://hten.isdg.cn/index/brand/GMP.png">
            <div class="brandGmpP">
              <p>GMP日本健康・栄養食品協会が、安全に生産管理がされることを</p>
              <p>目指した工場を認めるGMP認定工場に認可されました</p>
            </div>
          </div>
          <table class="brandTbleTwo">
            <tr v-for="item in table2">
              <td><span v-for="Message in item.tr">{{Message.title}}</span></td>
              <td><p v-for="Message in item.tr">{{Message.text}}</p></td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default{
    name: "",
    data(){
      return {
        msg: 'hello vue',
//        goog_1: require("../../assets/images/brand/brang_01.png"),
        projectimg: require("../../assets/images/brand/project.jpg"),
        table1: [
          {
            id: 0,
            tr: [
              {title: "設立"},
              {text: "平成26年7月"}
            ]
          },
          {
            id: 1,
            tr: [
              {title: "資本金"},
              {text: "980万円"}
            ]
          },
          {
            id: 2,
            tr: [
              {title: "代表者"},
              {text: "代表取締役　登坂嚇男"}
            ]
          },
          {
            id: 3,
            tr: [
              {title: "住所"},
              {text: "埼玉県さいたま市岩槻区上野6"},
              {text: "〒339-0073　TEL.0120-235-380"}
            ]
          },
          {
            id: 4,
            tr: [
              {title: "事業内容"},
              {text: "1.健康食品の製造ならびに販売"},
              {text: "2.化粧品の販売"},
              {text: "3.食品包装機械、プラントの設計、製作、販売"},
              {text: "4.こんにゃく原料の製造ならびに販売"},
              {text: "5.包装資材の販売"},
            ]
          },
        ],
        table2: [
          {
            id: 0,
            tr: [
              {title: "製造所"},
              {text: "株式会社玄聖 第一工場"},
            ]
          },
          {
            id: 1,
            tr: [
              {title: "認定範囲"},
              {text: "製品（製剤工程：顆粒、粉末、錠、ハードカプセル）"},
              {text: "(製剤工程：顆粒、粉末、錠、ハードカプセル、ソフトカプセル)"},
            ]
          },
          {
            id: 2,
            tr: [
              {title: "登録年度"},
              {text: "2016年"},
            ]
          },
        ]
      }
    },
    methods: {},
    components: {}
  }
</script>
<style lang="scss">
  @import "../../../static/pubilc";

  @media screen and(min-width: 0px) and(max-width: 749px) {
    .brand {
      margin-bottom: 51px;
      background-color: white;
      font-size: 16/$default-w+rem;
      .brandTop {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        height: 50px;
        line-height: 50px;
        background-color: $navcolor;
        color: white;
        text-align: center;
        letter-spacing: $letter;
      }
      .brand_img1 {
        margin-top: 50px;
        height: 130/$default-w+rem;
        width: 100%;
        padding: 2px 0;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .brandTitle {
        display: none;
      }
      .brandTbleOne, .brandTbleTwo {
        width: 100%;
        margin: 5px auto;
        border-collapse: collapse;
        font-size: 14/$default-w+rem;
        tr {
          td {
            border: 1px solid #aaa;
            padding: 10px 0;
            box-sizing: border-box;
          }
          td:nth-child(1) {
            text-align: center;
            width: 2.5rem;
            background-color: #f6f7f9;
          }
          td:nth-child(2) {
            width: 7.3rem;
            padding: 10px 0.1rem;
            box-sizing: border-box;
            p {
              text-indent: 2em;
            }
          }
        }
      }
      .projectimg {
        width: 100%;
        height: 216/$default-w+rem;
        margin: 10px auto;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .brandSrsc {
        width: 98%;
        padding: 5px 1%;
        background-color: #f6f7f9;
        line-height: 30px;
        letter-spacing: $letter;
        text-indent: 1em;
        font-size: 14/$default-w+rem;
      }
      .brandText {
        width: 100%;
        padding: 5px 2%;
        box-sizing: border-box;
        line-height: 25/$default-w+rem;
        margin: 0 auto;
        text-indent: 2em;
        font-size: 14/$default-w+rem;
        letter-spacing: $letter;
      }
      .gongimg {
        margin: 15px auto;
        display: flex;
        justify-content: space-around;
        img {
          width: 33%;
          height: 130px;
        }
      }
      .brandGmp {
        width: 100%;
        display: flex;
        justify-content: space-around;
        img {
          width: 37%;
          height: 120/$default-w+rem;
        }
        .brandGmpP {
          width: 58%;
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          margin: 0 1%;
          font-size: 14/$default-w+rem;
          p {
            width: 100%;
            margin-top: 7px;
            line-height: 20/$default-w+rem;
          }
        }
      }
    }
  }

  @media screen and(min-width: 750px) and(max-width: 1279px) {
    .brand {
      margin: 0 auto;
      min-width: 750px;
      background-color: white;
      .brandTop {
        display: none;
      }
      .brand_img1 {
        width: 100%;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .brandTitle {
        height: 80px;
        width: 100%;
        text-align: center;
        line-height: 100px;
        background-color: #f6f7f9;
        font-size: 20px;
        font-weight: 600;
        letter-spacing: 4px;
      }
      .brandContent {
        width: 100%;
        padding-bottom: 30px;
        background-color: #f6f7f9;
        .brandCountMain{
          width: 100%;
          max-width: 852px;
          margin: 0 auto;
          background-color: white;
          .brandTbleOne, .brandTbleTwo {
            width: 100%;
            height: 500px;
            margin: 0 auto;
            border-collapse: collapse;
            tr {
              td {
                line-height: 40px;
                border: 1px solid #aaa;
              }
              td:nth-child(1) {
                vertical-align: top;
                width: 150px;
                background-color: #f6f7f9;
                span {
                  /*display: inline-block;*/
                  width: 80px;
                  margin-left: 10px;
                }
              }
              td:nth-child(2) {
                p {
                  text-indent: 2em;
                }
              }
            }
          }
          .brandTbleTwo {
            width: 100%;
            height: 200px;
            tr {
              td:nth-child(1) {
                width: 240px;
              }
            }
          }
          .projectimg {
            width: 100%;
            margin: 40px auto;
            img {
              width: 100%;
              height: 481px;
            }
          }
          .brandSrsc {
            width: 100%;
            margin: 10px auto;
            background-color: #f6f7f9;
            line-height: 30px;
            letter-spacing: 1px;
            text-indent: 1em;
            font-size: 20px;
          }
          .brandText {
            width: 100%;
            line-height: 25px;
            margin: 0 auto;
            padding: 0 1%;
            box-sizing: border-box;
            margin-top: 5px;
            letter-spacing: 1px;
          }
          .gongimg {
            margin: 30px auto;
            display: flex;
            justify-content: space-around;
            img {
              width: 260px;
              height: 230px;
            }
          }
          .brandGmp {
            height: 120px;
            width: 100%;
            display: flex;
            img {
              width: 140px;
              height: 120px;
            }
            .brandGmpP {
              width: 670px;
              margin-left: 10px;
              margin-top: 30px;
              p {
                height: 30px;
                width: 500px;
              }
            }
          }
        }
      }
    }
  }

  @media screen and(min-width: 1280px) {
    .brand {
      margin: 0 auto;
      min-width: 992px;
      background-color: white;
      .brandTop {
        display: none;
      }
      .brand_img1 {
        width: 100%;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .brandTitle {
        height: 80px;
        width: 100%;
        text-align: center;
        line-height: 100px;
        background-color: #f6f7f9;
        font-size: 20px;
        font-weight: 600;
        letter-spacing: 4px;
      }
      .brandContent {
        width: 100%;
        padding-bottom: 30px;
        background-color: #f6f7f9;
        .brandCountMain{
          width: 100%;
          max-width: 852px;
          margin: 0 auto;
          background-color: white;
          .brandTbleOne, .brandTbleTwo {
            width: 100%;
            height: 500px;
            margin: 0 auto;
            border-collapse: collapse;
            tr {
              td {
                line-height: 40px;
                border: 1px solid #aaa;
              }
              td:nth-child(1) {
                vertical-align: top;
                width: 150px;
                background-color: #f6f7f9;
                span {
                  display: inline-block;
                  width: 80px;
                  margin-left: 20px;
                }
              }
              td:nth-child(2) {
                p {
                  text-indent: 2em;
                }
              }
            }
          }
          .brandTbleTwo {
            width: 100%;
            height: 200px;
            tr {
              td:nth-child(1) {
                width: 240px;
              }
            }
          }
          .projectimg {
            width: 100%;
            /*height: 481px;*/
            margin: 40px auto;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .brandSrsc {
            width: 100%;
            margin: 10px auto;
            background-color: #f6f7f9;
            line-height: 30px;
            letter-spacing: 1px;
            text-indent: 1em;
            font-size: 20px;
          }
          .brandText {
            width: 100%;
            line-height: 25px;
            margin: 0 auto;
            padding: 0 1%;
            box-sizing: border-box;
            margin-top: 5px;
            letter-spacing: 1px;
          }
          .gongimg {
            margin: 30px auto;
            display: flex;
            justify-content: space-around;
            img {
              width: 260px;
              height: 230px;
            }
          }
          .brandGmp {
            height: 120px;
            width: 100%;
            img {
              width: 140px;
              height: 120px;
              float: left;
            }
            .brandGmpP {
              width: 670px;
              float: right;
              margin-left: 10px;
              margin-top: 30px;
              p {
                height: 30px;
                width: 500px;
              }
            }
          }
        }

      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/brand/brand.vue